(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["retail-resource-mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const mediaQuery = window.matchMedia('(min-width: 750px)');

    const syncCwillMegaAccordions = () => {
      document.querySelectorAll('[data-cwill-dynamic-mega]').forEach((megaMenu) => {
        megaMenu.querySelectorAll('[data-mega-accordion]').forEach((accordion) => {
          if (mediaQuery.matches) {
            accordion.setAttribute('open', '');
            accordion.dataset.mobileReady = '';
          } else if (!accordion.dataset.mobileReady) {
            accordion.removeAttribute('open');
            accordion.dataset.mobileReady = 'true';
          }
        });
      });
    };

    syncCwillMegaAccordions();

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', syncCwillMegaAccordions);
    } else {
      mediaQuery.addListener(syncCwillMegaAccordions);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
